import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yjakje8bv3: FaireBrandEntity = {
  token: "b_yjakje8bv3",
  type: "brand",
  name: "Casey Jo Paper Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/0411e1251a88cc7a09a10c38a5200a240dccc4efe8d855f5e4459da7fff11ccb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7486233d16595fea1afc70809c54563d6d49480725f931326ee145bffa7e878e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0411e1251a88cc7a09a10c38a5200a240dccc4efe8d855f5e4459da7fff11ccb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7486233d16595fea1afc70809c54563d6d49480725f931326ee145bffa7e878e.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "Casey Jo Paper Co. creates coordinated paper goods and embroidered linens for hosting, tabletop, kitchen, bar and everyday gifting sections.\n\nEach collection begins as an original watercolor painting and is translated into cohesive pieces that merchandise naturally together, from recipe cards and notelets to cocktail and dinner napkins.\n\nThe brand is built around the small choices that make daily life feel intentional—using a cute cloth napkin with Chinese takeout, writing an aesthetic grocery list before heading to the store, or labeling the cheeses before a friend comes over. Our customer notices those details, and she buys them as gifts for the people in her life who do too.\n\nOpening orders begin at $150 with quick 2-5 day fulfillment. \n\nWe look forward to partnering with you!\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:07.995Z",
    importedBy: "entity-db-cli",
  },
};
